import { gql, useMutation } from '@apollo/client';

import { CreateApiKey } from './__generated__/CreateApiKey';
import { GET_APIKEYS } from './useGetApiKeys';

const CREATE_APIKEYS = gql`
  mutation CreateApiKey($name: String!) {
    createApiKey(name: $name) {
      apiKey {
        name
        key
      }
      error
    }
  }
`;

export default function useCreateApiKey() {
  const [createApiKeyQL, { data, error, loading }] = useMutation<CreateApiKey>(
    CREATE_APIKEYS,
    {
      refetchQueries: [GET_APIKEYS, 'GetApiKeys'],
    },
  );

  const createApiKey = async (name: string) => {
    if (name) {
      const { data } = await createApiKeyQL({
        variables: { name },
      });

      return data ? data.createApiKey : null;
    }
    return Promise.resolve(null);
  };
  return [createApiKey, { data, error, loading }] as const;
}
